import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center">
            <div className="flex-1 w-full text-center md:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                {aboutData.title}
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                {aboutData.description}
              </p>

              <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
                {aboutData.stats.map((stat) => (
                  <div key={stat.label} className="text-center p-3 bg-background-100 rounded-lg">
                    <div className="text-lg md:text-xl font-bold text-primary-500 font-heading">
                      {stat.value}
                    </div>
                    <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="w-full max-w-xs lg:max-w-sm shrink-0">
              <div className="relative">
                <div className="absolute -inset-3 bg-gradient-to-br from-primary-500/8 to-accent-500/8 rounded-2xl blur-md" />
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20streaming%20platform%20concept%20with%20warm%20coral%20and%20golden%20ambient%20lighting%2C%20abstract%20geometric%20shapes%20representing%20media%20content%2C%20dark%20background%20with%20soft%20glow%2C%20professional%20and%20trustworthy%20atmosphere%2C%20clean%20composition%2C%20no%20text%20or%20logos&width=600&height=500&seq=about-platform-01&orientation=landscape"
                  alt="木瓜影视平台介绍"
                  title="木瓜影视-高清电视剧平台"
                  className="relative w-full rounded-xl object-cover"
                  style={{ aspectRatio: '6/5' }}
                  onError={(e) => {
                    const target = e.currentTarget;
                    const parent = target.parentElement;
                    if (parent) parent.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}